<template>
	<div class="shoppingcart-po__create__notice">
		<svg class="icon-notice" height="16" width="16">
			<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#notice"></use>
		</svg>

		<span>
			<slot />
		</span>
	</div>
</template>

<style scoped lang="scss">
	@use "sass:math";
	@import '../../../../../../src/main/webapp/template/assets/css/source/settings';

	.shoppingcart-po__create__notice {
		position: relative;
		padding: 5px 45px 5px 5px;
		text-align: right;
		font-size: math.div(14, 16)*1em;
		line-height: math.div(18, 14)*1em;

		svg {
			position: absolute;
			right: 20px;
			color: $color-dummen-orange;
		}
	}
</style>
